module.exports = __webpack_public_path__ + "media/src/assets/Images/TopArrow-4e879b72bb25511887eb834e33a2341f.svg";